import type { FaireProductEntity } from "../../entity_types/product";

export const p_xp2fbzdm6g: FaireProductEntity = {
  token: "p_xp2fbzdm6g",
  type: "product",
  name: "Apple a Day Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/595efde3fd23a6bfb28a81e94e89f5eeb99f97246267393fe03e47a3802b3a6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/528fcec1277720862c0b85a9b67f087c9b1a1f02148c8f3a90ad7f3a91eb033a.jpeg",
    "https://cdn.faire.com/fastly/5e6d246973cd5e6c254ab1cb22582325483d951c187b4825074872161a177738.jpeg"
  ],
  priceDollars: 5,
  description: "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:35.355Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
